import { Add, Close, Delete } from "@mui/icons-material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import React, { memo, useRef, useState } from "react";
import { BIGrey } from "../../../../assets/helpers";
import PictureViewer from "../../../../common/PictureViewer";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";
import { useSelector } from "react-redux";
import { ClientTimesheetUDFieldComponent } from "../../shared/components/TimesheetUDFields";

const purifyTime = (time) => {
  try {
    if (time === undefined || time === null || time == "0:00") {
      return "0.00";
    }
    const [hours, min] = time.toString().split(":");
    let formattedTime = "";
    if (hours[0] == "0") {
      return `${hours[1]}:${min}`;
    }
    if (Number(hours) > 9) {
      formattedTime = `${hours}:${min}`;
    } else {
      formattedTime = `${min}`;
    }

    return formattedTime;
  } catch (error) {
    console.error("purifyTime-> Error formatting time: ", error);
    return time;
  }
};

function formatTime(timeStr) {
  // Match groups: hour, minutes, and AM/PM
  const timeRegex = /(\d{1,2}):(\d{2})/;
  const match = timeStr.match(timeRegex);
  if (!match) return timeStr; // Return original string if it doesn't match
  const hour = parseInt(match[1], 10);
  const minutes = match[2];
  const ampm = match[3];
  // Convert to 12-hour format
  const formattedHour = hour % 12 || 12; // Convert hour to 12-hour format
  const formattedTime = `${formattedHour}:${minutes}${ampm ? ampm : ""}`;
  return formattedTime;
}

export const JobsListing = memo(
  ({
    index,
    item,
    loading,
    isPrimary,
    CLIENT_COLOR,
    handelDelete,
    handelExpand,
    handelClockIn,
    buttonDisable,
    handelClockOut,
    handelAddImage,
    handelImageRemove,
    handelNotesChange,
    handelMileageBlur,
    handelSelectChange,
    handelJobUdFieldChange,
    handelActivityUdFieldChange
  }) => {
    const inputRef = useRef();
    const handelInputClick = () => {
      if (inputRef?.current) {
        inputRef.current?.click();
      }
    };

    const { multiLanguageData } = useSelector((state) => state?.main);

    const {
      TEXT_CLOCK_IN,
      TEXT_OUT,
      TEXT_CLOCK_OUT,
      TEXT_HOURS,
      TEXT_MILEAGE,
      TEXT_JOBPOSTING_OPTIONAL,
      TEXT_DETAIL_MODAL_KM,
      TEXT_MI,
      TEXT_WRITE_SOMETHING,
      TEXT_IN
    } = ClientEnglishFallback?.JobsListing(multiLanguageData?.JobsListing || {});

    let clockInTime =
      item?.timesheetHours?.clockInTime == "00:00"
        ? "--:--"
        : dayjs(item?.timesheetHours?.clockInTime).format("hh:mm") == "Invalid Date"
          ? item?.timesheetHours?.clockInTime
          : dayjs(item?.timesheetHours?.clockInTime).format("h:mm ");

    let clockOutTime =
      item?.timesheetHours?.clockOutTime == "00:00"
        ? "--:--"
        : dayjs(item?.timesheetHours?.clockOutTime).format("hh:mm") == "Invalid Date"
          ? item?.timesheetHours?.clockOutTime
          : dayjs(item?.timesheetHours?.clockOutTime).format("h:mm");

    return (
      <Stack
        sx={{
          border: "1px solid #e4e4e4",
          bgcolor: "white",
          borderRadius: "10px",
          cursor: "pointer"
        }}>
        <Grid
          sx={{
            padding: "10px"
          }}
          size={12}
          spacing={1}
          container
          key={index}
          style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid size={12}>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} width={"100%"}>
              <Stack justifyItems={"center"}>
                <Typography
                  sx={{
                    wordBreak: "break-all",
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                    fontSize: "17px",
                    fontWeight: "bold"
                  }}>
                  {`${item?.clientJobCode} - ${item?.clientJobName}`}
                </Typography>
                {item?.timesheetActivities && (
                  <Typography
                    sx={{
                      wordBreak: "break-all",
                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      color: BIGrey
                    }}>
                    {item?.timesheetActivities?.clientJobActivityCode} -
                    {item?.timesheetActivities?.clientJobActivityName}
                  </Typography>
                )}
              </Stack>
              <Stack sx={{ gap: 1 }}  direction={"row"}>
                <IconButton
                  onClick={() => {
                    handelDelete(index, item);
                  }}
                  size="small">
                  <Delete
                    sx={{
                      color: CLIENT_COLOR
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => {
                    handelExpand(index);
                  }}
                  size="small">
                  {item?.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Stack>
            </Stack>
          </Grid>

          <Grid spacing={1} container size={12}>
            <Grid size={4}>
              <Stack>
                <Typography
                  sx={{
                    color: BIGrey,
                    textAlign: "center"
                  }}>
                  {TEXT_IN}
                </Typography>
                {item?.clockinStatus ? (
                  <Typography
                    sx={{
                      backgroundColor: "#e4e4e4",
                      borderRadius: "10px",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "black",
                      textAlign: "center",
                      padding: "5px"
                    }}>
                    {formatTime(clockInTime)}
                  </Typography>
                ) : (
                  <LoadingButton
                    disabled={buttonDisable}
                    loadingIndicator={
                      <CircularProgress
                        sx={{
                          color: CLIENT_COLOR
                        }}
                        size={16}
                      />
                    }
                    startIcon={<></>}
                    loading={loading?.id == item?.timesheetHours?.id && loading?.num == 1}
                    loadingPosition="start"
                    onClick={() => {
                      handelClockIn(item?.timesheetHours, index);
                    }}
                    variant={isPrimary ? "outlined" : buttonDisable ? "contained" : ""}
                    sx={{
                      borderColor: isPrimary ? CLIENT_COLOR : "",
                      backgroundColor: isPrimary ? "" : CLIENT_COLOR,
                      color: isPrimary ? CLIENT_COLOR : "white",
                      borderRadius: "10px",
                      textTransform: "none",
                      boxShadow: "none"
                    }}>
                    {TEXT_CLOCK_IN}
                  </LoadingButton>
                )}
              </Stack>
            </Grid>
            <Grid size={4}>
              <Stack>
                <Typography
                  sx={{
                    wordBreak: "break-all",
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                    color: BIGrey,
                    textAlign: "center"
                  }}>
                  {TEXT_OUT}
                </Typography>

                {item?.clockoutStatus || !item?.clockinStatus ? (
                  <Typography
                    sx={{
                      backgroundColor: "#e4e4e4",
                      borderRadius: "10px",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "black",
                      textAlign: "center",
                      padding: "5px"
                    }}>
                    {formatTime(clockOutTime)}
                  </Typography>
                ) : (
                  <LoadingButton
                    disabled={buttonDisable}
                    loadingIndicator={
                      <CircularProgress
                        sx={{
                          color: CLIENT_COLOR
                        }}
                        size={16}
                      />
                    }
                    startIcon={<></>}
                    loading={loading?.id == item?.timesheetHours?.id && loading?.num == 2}
                    loadingPosition="start"
                    variant={
                      buttonDisable ? "contained" : item?.clockinStatus ? "outlined" : "contained"
                    }
                    onClick={() => handelClockOut(item?.timesheetHours, index)}
                    sx={{
                      borderColor: !item?.clockinStatus ? CLIENT_COLOR : "transparent",
                      backgroundColor: !item?.clockinStatus ? "" : CLIENT_COLOR,
                      color: !item?.clockinStatus ? CLIENT_COLOR : "white",
                      borderRadius: "10px",
                      textTransform: "none"
                    }}>
                    {TEXT_CLOCK_OUT}
                  </LoadingButton>
                )}
              </Stack>
            </Grid>
            <Grid size={4}>
              <Stack>
                <Typography
                  sx={{
                    wordBreak: "break-all",
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                    color: BIGrey,
                    textAlign: "center"
                  }}>
                  {TEXT_HOURS}
                </Typography>
                <Typography sx={{ padding: "5px 0px" }} textAlign={"center"}>
                  {purifyTime(item?.timesheetHours?.hours)}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>

        {item?.expanded && (
          <Grid
            sx={{
              padding: "10px",
              borderRadius: "0px 0px 10px 10px",
              backgroundColor: "#fafafa",
              gap: 1
            }}
            container>
            <Grid sx={{ gap: 1 }} size={12}  container>
              <Grid size={5}>
                <Stack>
                  <Typography>{TEXT_MILEAGE}</Typography>
                  <TextField
                    onFocus={() => {
                      handelSelectChange("", index, "mileage");
                    }}
                    onChange={(e) => {
                      handelSelectChange(e.target.value, index, "mileage");
                    }}
                    value={
                      item?.timesheetEmployees?.mileage == 0
                        ? ""
                        : item?.timesheetEmployees?.mileage
                    }
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0"
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        border: "none"
                      },
                      background: "#e4e4e4",
                      borderRadius: "10px"
                    }}
                    onBlur={() =>
                      handelMileageBlur(index, item?.timesheetEmployees?.mileage)
                    }
                    type="number"
                    placeholder={TEXT_JOBPOSTING_OPTIONAL}
                    fullWidth
                  />
                </Stack>
              </Grid>
              <Grid sx={{ alignSelf: "end" }} size={4}>
                <Select
                  size="small"
                  fullWidth
                  value={item?.timesheetEmployees?.mileageUnit}
                  onChange={(e) => {
                    handelSelectChange(e.target.value, index, "mileageUnit");
                  }}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  sx={{
                    "& fieldset": { border: "none" }
                  }}>
                  <MenuItem value={"km"}>{TEXT_DETAIL_MODAL_KM}</MenuItem>
                  <MenuItem value={"mi"}>{TEXT_MI}</MenuItem>
                </Select>
              </Grid>
              <Grid size={12}>
                <TextField
                  fullWidth
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0",
                      padding: " 5px 10px"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  rows={5}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    handelNotesChange(inputValue, index, "notes");
                  }}
                  value={item.notes}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  placeholder={TEXT_WRITE_SOMETHING}
                />
              </Grid>
            </Grid>

            <Grid size={12} sx={{ mt: 2 }}>
              <Stack
                sx={{
                  scrollbarWidth: "none",
                  width: "100%",
                  overflowX: "auto"
                }}
                direction={"row"}
                spacing={1}>
                <input
                  onChange={(e) => handelAddImage(e, index)}
                  type="file"
                  ref={inputRef}
                  hidden
                  accept="image/*"
                  multiple
                />
                <div
                  onClick={handelInputClick}
                  style={{
                    margin: "0px",
                    border: "1px solid #e4e4e4",
                    borderRadius: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    height: "100px",
                    width: "100px",
                    minWidth: "100px"
                  }}>
                  <Add />
                </div>
                <ImageComponent
                  item={item?.pictureList}
                  handelImageRemove={handelImageRemove}
                  jobIndex={index}
                />
              </Stack>
            </Grid>

            {item?.timesheetActivities && (
              <Grid size={12}>
                <ClientTimesheetUDFieldComponent
                  udFields={item?.timesheetActivities?.udFieldsList}
                  onChange={handelActivityUdFieldChange}
                  index={index}
                />
              </Grid>
            )}
            {item?.udFieldsList?.length > 0 && (
              <Grid>
                <ClientTimesheetUDFieldComponent
                  udFields={item?.udFieldsList}
                  onChange={handelJobUdFieldChange}
                  index={index}
                />
              </Grid>
            )}
          </Grid>
        )}
      </Stack>
    );
  }
);

export const ImageComponent = memo(({ item, handelImageRemove, jobIndex }) => {
  const [imagePreview, setImagePreview] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const handelPreview = () => {
    setImagePreview(true);
  };
  const createObjectURL = (file) => {
    try {
      return URL.createObjectURL(file);
    } catch (e) {
      console.log('createObjectURL-> Error When Creating Object URL: ',e);
      return file;
    }
  };
  return (
    <>
      <PictureViewer
        isOpen={imagePreview}
        onClose={() => setImagePreview(false)}
        pictures={item?.map((pic) => ({
          src: pic.src || createObjectURL(pic.file),
          alt: ""
        }))}
        viewerIndex={imageIndex}
      />
      {item?.map((file, i) => {
        return (
          <div
            style={{
              position: "relative"
            }}>
            <Close
              onClick={() => {
                handelImageRemove(i, jobIndex, file);
              }}
              sx={{
                background: "white",
                borderRadius: "20px",
                position: "absolute",
                right: "0px",
                top: "2px",
                color: "red"
              }}
            />
            <img
              onClick={() => {
                setImageIndex(i);
                handelPreview();
              }}
              style={{
                height: "100px",
                minWidth: "100px",
                maxWidth: "100px",
                cursor: "pointer",
                borderRadius: "10px",
                objectFit: "cover"
              }}
              src={file?.thumbFileUrl || createObjectURL(file?.file)}
              alt=""
            />
          </div>
        );
      })}
    </>
  );
});

